import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const titleSx = { fontWeight: 800, fontSize: '1.1rem', mb: 2, color: 'text.primary' } as const
const pSx = { color: 'text.secondary', lineHeight: 1.65, mb: 1.5 } as const
const listSx = { m: 0, pl: 2.5, mb: 1.5, color: 'text.secondary' } as const
const liSx = { mb: 0.75, lineHeight: 1.65 } as const

function Li({ children }: { children: string }) {
  return (
    <Typography component="li" variant="body2" sx={liSx}>
      {children}
    </Typography>
  )
}

/** Texte court affiché sur l’écran d’acceptation (popup / gate), aligné sur le pack légal 01_POPUP_ACCEPTATION. */
export function CguAcceptPopupBody() {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="h6" component="h2" sx={titleSx}>
        {t('cgu.titre')}
      </Typography>

      <Typography variant="body2" sx={pSx}>
        {t('cgu.popup_intro')}
      </Typography>

      <Typography variant="body2" sx={{ ...pSx, fontWeight: 600, color: 'text.primary', mb: 1 }}>
        {t('cgu.popup_results_intro')}
      </Typography>
      <Box component="ul" sx={listSx}>
        <Li>{t('cgu.popup_results_1')}</Li>
        <Li>{t('cgu.popup_results_2')}</Li>
        <Li>{t('cgu.popup_results_3')}</Li>
        <Li>{t('cgu.popup_results_4')}</Li>
      </Box>

      <Typography variant="body2" sx={pSx}>
        {t('cgu.popup_validation')}
      </Typography>
      <Typography variant="body2" sx={pSx}>
        {t('cgu.popup_responsibility')}
      </Typography>

      <Typography variant="body2" sx={{ ...pSx, fontWeight: 600, color: 'text.primary', mb: 1 }}>
        {t('cgu.popup_liability_intro')}
      </Typography>
      <Box component="ul" sx={listSx}>
        <Li>{t('cgu.popup_liability_1')}</Li>
        <Li>{t('cgu.popup_liability_2')}</Li>
        <Li>{t('cgu.popup_liability_3')}</Li>
        <Li>{t('cgu.popup_liability_4')}</Li>
        <Li>{t('cgu.popup_liability_5')}</Li>
        <Li>{t('cgu.popup_liability_6')}</Li>
        <Li>{t('cgu.popup_liability_7')}</Li>
      </Box>

      <Typography variant="body2" sx={{ ...pSx, fontWeight: 600, color: 'text.primary', mb: 1 }}>
        {t('cgu.popup_accept_intro')}
      </Typography>
      <Box component="ul" sx={{ ...listSx, mb: 2 }}>
        <Li>{t('cgu.popup_accept_1')}</Li>
        <Li>{t('cgu.popup_accept_2')}</Li>
        <Li>{t('cgu.popup_accept_3')}</Li>
        <Li>{t('cgu.popup_accept_4')}</Li>
      </Box>
    </Box>
  )
}
